document.addEventListener('DOMContentLoaded', () => {
    const countdownElements = document.querySelectorAll('.countdown-timer');
  
    countdownElements.forEach(elem => {
      const countdownData = elem.getAttribute('data-countdown-timer');
      if (!countdownData) {
        return;
      }
      
      try {
        const { epoch } = JSON.parse(countdownData);
        if (!epoch) {
          return;
        }
        
        const dateTimeParts = epoch.split(' ');
        const dateParts = dateTimeParts[0].split('-');
        const timeParts = dateTimeParts[1].split(':');
        const month = parseInt(dateParts[0], 10) - 1; 
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const hour = parseInt(timeParts[0], 10);
        const minute = parseInt(timeParts[1], 10);
        const targetTime = new Date(year, month, day, hour, minute).getTime();
    
        const updateCountdown = () => {
          const currentTime = new Date().getTime();
          const difference = targetTime - currentTime;
    
          if (difference <= 0) {
            clearInterval(interval);
            elem.innerHTML =  `<span class="countdown-unit" data-time="days"><span class="countdown-value">00</span><span class="countdown-label">Days</span></span><span class="countdown-unit" data-time="hours"><span class="countdown-value">00</span><span  class="countdown-label">Hours</span></span><span data-time="minutes" class="countdown-unit"><span class="countdown-value">00</span><span  class="countdown-label">Minutes</span></span><span class="countdown-unit" data-time="seconds"><span class="countdown-value">00</span><span  class="countdown-label">seconds</span></span> `;
            return;
          }
    
          const days = Math.floor(difference / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
          const hours = Math.floor((difference / (1000 * 60 * 60)) % 24).toString().padStart(2, '0');
          const minutes = Math.floor((difference / (1000 * 60)) % 60).toString().padStart(2, '0');
          const seconds = Math.floor((difference / 1000) % 60).toString().padStart(2, '0');
    
          elem.innerHTML = `<span class="countdown-unit" data-time="days"><span class="countdown-value">${days}</span><span class="countdown-label">Days</span></span><span class="countdown-unit" data-time="hours"><span class="countdown-value">${hours}</span><span  class="countdown-label">Hours</span></span><span data-time="minutes" class="countdown-unit"><span class="countdown-value">${minutes}</span><span  class="countdown-label">Minutes</span></span><span class="countdown-unit" data-time="seconds"><span class="countdown-value">${seconds}</span><span  class="countdown-label">Seconds</span></span> `;
        };
    
        const interval = setInterval(updateCountdown, 1000);
        updateCountdown();
      } catch (error) {
        console.error('Invalid JSON in data-countdown-timer attribute:', error);
      }
    });
  });
  